import styled from '@emotion/styled';

export const SContainer = styled.div`
  background: white;
  padding: 12px;
  position: relative;
  width: 252px;
`;

export const STitle = styled.div`
  color: #595959;
`;

export const SValue = styled.div`
  margin-top: 5px;
  font-family: 'Roboto';
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  color: rgba(0, 0, 0, 0.85);
`;

export const SIcon = styled.div`
  position: absolute;
  top: 13px;
  right: 13px;
`;
